module.exports = __webpack_public_path__ + "img/area_5.8bbd7c50.png";